import React, { useState } from 'react';

const ApiTestPage = () => {
    const [token, setToken] = useState('');
    const [apiUrl, setApiUrl] = useState('');
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // ฟังก์ชันเช็ค token และ API
    const handleTestApi = async () => {
        setLoading(true);
        setError(null);
        setResponse(null);

        try {
            const res = await fetch(apiUrl, {
                method: 'GET', // ใช้ตามที่ API ของคุณต้องการ (GET/POST)
                headers: {
                    'Authorization': `Bearer ${token}`, // ใส่ token ที่กรอก
                },
            });

            if (!res.ok) throw new Error('ไม่สามารถเชื่อมต่อกับ API ได้');

            const data = await res.json();
            setResponse(data); // แสดงผลลัพธ์ที่ได้จาก API
        } catch (err) {
            setError(err.message); // ถ้ามี error จะแสดง
        } finally {
            setLoading(false); // ปิด loading
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
            <div className="card p-4" style={{ width: '100%', maxWidth: '500px', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <h2 className="text-center mb-4">ทดสอบ Token และ API</h2>

                <div className="mb-3">
                    <label htmlFor="tokenInput" className="form-label">Token</label>
                    <input
                        type="text"
                        className="form-control"
                        id="tokenInput"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        placeholder="กรุณากรอก Token"
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="apiUrlInput" className="form-label">API URL</label>
                    <input
                        type="text"
                        className="form-control"
                        id="apiUrlInput"
                        value={apiUrl}
                        onChange={(e) => setApiUrl(e.target.value)}
                        placeholder="กรุณากรอก API URL"
                    />
                </div>

                <button onClick={handleTestApi} className="btn btn-primary mb-3">
                    ทดสอบ API
                </button>

                {loading && <p>⏳ กำลังทดสอบ...</p>}

                {error && (
                    <div className="alert alert-danger">
                        <strong>ข้อผิดพลาด:</strong> {error}
                    </div>
                )}

                {response && (
                    <div className="alert alert-success">
                        <h5>ผลลัพธ์จาก API</h5>
                        <pre style={{ maxHeight: '300px', overflowY: 'auto', width: 'auto' }}>
                            {JSON.stringify(response, null, 2)}
                        </pre>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ApiTestPage;
